import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import { Container, BackgroundImage } from 'components';
import './Section.scss';

const Section = ({
  additionalClass,
  containerClass,
  background,
  children,
  color,
  fullwidth,
  spaceless,
  stick,
  side,
  spacedTop,
  id,
  alt,
}) => {
  const backgroundClass = background ? 'section--background' : '';
  const spaceClass = spaceless ? 'section--spaceless' : '';
  const spaceTopClass = spacedTop ? 'section--spaced-top' : '';

  return background ? (
    <div
      id={id}
      className={`section section--${color} ${spaceTopClass} ${spaceClass} ${backgroundClass} ${additionalClass} ${id}`}
    >
      <LazyLoad once offset={200} height={300}>
        <BackgroundImage
          src={background}
          alt={alt}
          additionalClass={'section__background-image'}
        />
      </LazyLoad>
      <Container
        fullwidth={fullwidth}
        stick={stick}
        side={side}
        additionalClass={containerClass}
      >
        {children}
      </Container>
    </div>
  ) : (
    <div
      id={id}
      className={`section section--${color} ${spaceClass} ${additionalClass} ${id} ${spaceTopClass}`}
    >
      <Container
        fullwidth={fullwidth}
        stick={stick}
        side={side}
        additionalClass={containerClass}
      >
        {children}
      </Container>
    </div>
  );
};

Section.defaultProps = {
  additionalClass: '',
  containerClass: '',
  color: 'transparent',
  fullwidth: false,
  stick: false,
  side: '',
  spaceless: false,
  id: '',
  alt: '',
  background: '',
  children: null,
  spacedTop: false,
};

Section.propTypes = {
  additionalClass: PropTypes.string,
  containerClass: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  fullwidth: PropTypes.bool,
  stick: PropTypes.bool,
  spaceless: PropTypes.bool,
  spacedTop: PropTypes.bool,
  id: PropTypes.string,
  alt: PropTypes.string,
  background: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  side: PropTypes.string,
};

export default Section;
